/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  VirtualRTTelemetryType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnVirtualRTTelemetryInput {
  loggerId?: string;
}
const build = (_query: DocumentNode, input: OnVirtualRTTelemetryInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onVirtualRTTelemetry(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' }
    ){
      ...virtualrttelemetrytype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnVirtualRTTelemetrySubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment virtualrttelemetrytype on VirtualRTTelemetryType { ... }
   */
  execute(_query: DocumentNode, input: OnVirtualRTTelemetryInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onVirtualRTTelemetry : Partial<VirtualRTTelemetryType>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
